module.exports = __webpack_public_path__ + "KW.png?246e255f060624b765f2d1566b5555c4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/KW.png
// module id = 372
// module chunks = 0